/* Native scrolling still works without JavaScript. */
if (!customElements.get('st-product-rail')) {
  customElements.define('st-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      this.track = this.querySelector('[data-st-product-track]');
      this.controls = this.querySelector('[data-st-rail-controls]');
      if (!this.track || !this.controls) return;
      this.previous = this.querySelector('[data-st-rail-prev]');
      this.next = this.querySelector('[data-st-rail-next]');
      this.status = this.querySelector('[data-st-rail-status]');
      const options = { signal: this.cleanup.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      window.addEventListener('resize', () => this.update(), options);
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.st-product');
        if (card && this.track.contains(card)) {
          this.track.scrollTo({ left: this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant' });
        }
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.cleanup?.abort();
      this.observer?.disconnect();
    }
    move(direction) {
      const card = this.track.querySelector('.st-product');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = max < 2;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      const cards = [...this.track.querySelectorAll('.st-product')];
      const bounds = this.track.getBoundingClientRect();
      const visible = cards.map((card, index) => ({ box: card.getBoundingClientRect(), index: index + 1 }))
        .filter(({ box }) => box.right > bounds.left + 3 && box.left < bounds.right - 3);
      if (visible.length) this.status.textContent = `${visible[0].index}〜${visible.at(-1).index} / ${cards.length}商品`;
    }
  });
}
